<template>
  <PageLayout
    :is-loading="isLoading"
    :page-title="pageTitle"
    :show-banner="false"
    :show-sponsors="false"
    :show-back-button="true"
    :hide-sidebar="true"
    @back="goBack"
  >
    <!-- Profile Edit Form -->
    <div class="profile-edit-section">
      <form @submit.prevent="submitData" class="profile-edit-form">
        
        <!-- Profile Photo Section -->
        <div v-if="editSection === 'profile'" class="edit-content">
          <div class="photo-section">
            <div class="profile-photo-container">
              <img 
                :src="getUserImage(imageUrl)" 
                alt="Profile" 
                class="profile-photo" 
                @error="handleImageError"
              />
              <button type="button" class="change-photo-btn" @click="triggerFileInput">
                Ubah Foto Profil
              </button>
              <input 
                type="file" 
                ref="fileInput" 
                @change="handleFileChange" 
                accept="image/*" 
                style="display: none;"
              />
              <p class="photo-info">
                Supported formats: JPG, PNG<br>
                Maximum size: 2MB
              </p>
            </div>
          </div>

          <div class="form-group">
            <label>Ubah Nama Profil :</label>
            <div class="input-with-icon">
              <i class="mdi mdi-account"></i>
              <input type="text" v-model="forms.name" placeholder="Della Sorenta" />
            </div>
          </div>
        </div>

        <!-- Basic Information Section -->
        <div v-if="editSection === 'basic'" class="edit-content">
          <div class="form-section">
            <div class="form-row">
              <div class="form-group">
                <label>Nama Lengkap :</label>
                <input type="text" v-model="forms.name" placeholder="Masukkan Nama Lengkap" />
              </div>
              <div class="form-group">
                <label>Tanggal Lahir :</label>
                <input type="date" v-model="forms.tanggal_lahir" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Jenis Kelamin :</label>
                <select v-model="forms.jenis_kelamin">
                  <option value="">Pilih Jenis Kelamin</option>
                  <option value="Laki-laki">Laki-laki</option>
                  <option value="Wanita">Wanita</option>
                </select>
              </div>
              <div class="form-group">
                <label>No. Handphone :</label>
                <input type="tel" v-model="forms.phone" placeholder="Masukkan No Handphone" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Community :</label>
                <select v-model="modelCommunity">
                  <option value="">Pilih Community</option>
                  <option v-for="item in community" :value="item.id" :key="item">{{ item.community }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Area Domisili :</label>
                <select v-model="forms.area_domisili">
                  <option value="">Pilih Area Domisili</option>
                  <option value="Jabodetabek">Jabodetabek</option>
                  <option value="Luar Jabodetabek">Luar Jabodetabek</option>
                </select>
              </div>
            </div>

            <div class="form-group full-width">
              <label>Alamat Lengkap :</label>
              <textarea v-model="forms.address" placeholder="Masukkan Alamat Lengkap"></textarea>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Provinsi :</label>
                <select v-model="modelProvinsi" @change="loadKota(modelProvinsi.kode)">
                  <option value="">Pilih Provinsi</option>
                  <option v-for="item in provinsi" :value="item" :key="item">{{ item.nama }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Kota :</label>
                <select v-model="modelKota" @change="loadKecamatan(modelKota.kode)">
                  <option value="">Pilih Kota</option>
                  <option v-for="item in kota" :value="item" :key="item">{{ item.nama }}</option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Kecamatan :</label>
                <select v-model="modelKecamatan">
                  <option value="">Pilih Kecamatan</option>
                  <option v-for="item in kecamatan" :value="item.nama" :key="item">{{ item.nama }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Kode Pos :</label>
                <input type="text" v-model="forms.kode_pos" placeholder="Pilih Kode Pos" />
              </div>
            </div>

            <div class="form-group full-width">
              <label>Personal KOL :</label>
              <select v-model="modelPersonal" multiple @change="validateSelection" style="height: 200px;">
                <option value="">Select multiple option. Max 5</option>
                <option v-for="item in personal" :value="item.personal" :key="item">{{ item.personal }}</option>
              </select>
              <p class="file-info">Hold Ctrl (Windows) or Cmd (Mac) to select multiple options. Maximum 5 selections.</p>
            </div>
          </div>
        </div>

        <!-- Privacy Section -->
        <div v-if="editSection === 'privacy'" class="edit-content">
          <div class="form-section">
            <div class="form-group full-width">
              <label>Email :</label>
              <input type="email" v-model="forms.email" placeholder="Ubah Alamat Email" />
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Kata Sandi Baru :</label>
                <input type="password" v-model="forms.password" placeholder="Ubah Kata Sandi" />
              </div>
              <div class="form-group">
                <label>Ulangi Kata Sandi Baru :</label>
                <input type="password" v-model="forms.password_confirmation" placeholder="Ulangi Kata Sandi Baru" />
              </div>
            </div>
          </div>
        </div>

        <!-- Social Media Section -->
        <div v-if="editSection === 'social'" class="edit-content">
          <div class="form-section">
            <div class="form-row">
              <div class="form-group">
                <label>Username Instagram :</label>
                <input type="text" v-model="forms.username_instagram" placeholder="@username" />
              </div>
              <div class="form-group">
                <label>Link Profile Instagram :</label>
                <input type="url" v-model="forms.profile_instagram" placeholder="https://instagram.com/username" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Followers Instagram :</label>
                <input type="number" v-model="forms.followers_instagram" placeholder="0" />
              </div>
              <div class="form-group">
                <label>Engagement Rate Instagram (%) :</label>
                <input type="number" step="0.01" v-model="forms.engagement_rate_instagram" placeholder="0.00" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Username TikTok :</label>
                <input type="text" v-model="forms.username_tiktok" placeholder="@username" />
              </div>
              <div class="form-group">
                <label>Link Profile TikTok :</label>
                <input type="url" v-model="forms.profile_tiktok" placeholder="https://tiktok.com/@username" />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Followers TikTok :</label>
                <input type="number" v-model="forms.followers_tiktok" placeholder="0" />
              </div>
              <div class="form-group">
                <label>Engagement Rate TikTok (%) :</label>
                <input type="number" step="0.01" v-model="forms.engagement_rate_tiktok" placeholder="0.00" />
              </div>
            </div>

            <div class="form-group full-width">
              <label>Device untuk Live Shopping :</label>
              <input type="text" v-model="forms.device" placeholder="e.g., iPhone 11" />
            </div>

            <div class="form-group full-width">
              <label>Upload Portfolio Video (30s - 1min) :</label>
              <input 
                type="file" 
                ref="fileInputPortofolio" 
                @change="handleFileChangePortofolio" 
                accept="video/*"
              />
              <p class="file-info">Supported formats: MP4, AVI, MOV, WMV. Maximum size: 10MB</p>
            </div>
          </div>
        </div>
        <div v-if="editSection === 'additional'" class="edit-content">
          <div class="form-section">
            <div class="form-group full-width">
              <label>Asal Group WhatsApp :</label>
              <select v-model="modelWagroup">
                <option value="">Pilih Asal Group Whatsapp</option>
                <option v-for="item in wagroup" :value="item.name" :key="item">{{ item.name }}</option>
              </select>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Tipe Kulit :</label>
                <select v-model="forms.skintype">
                  <option value="">Pilih Tipe Kulit</option>
                  <option value="Normal Skin">Normal Skin</option>
                  <option value="Dry Skin">Dry Skin</option>
                  <option value="Oily Skin">Oily Skin</option>
                  <option value="Combination Skin">Combination Skin</option>
                  <option value="Acne Prone Skin">Acne Prone Skin</option>
                  <option value="Sensitive Skin">Sensitive Skin</option>
                </select>
              </div>
              <div class="form-group">
                <label>Apakah Anda menggunakan hijab?</label>
                <div class="radio-group">
                  <label class="radio-option">
                    <input type="radio" v-model="forms.hijab" value="Ya" />
                    <span>Ya</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="forms.hijab" value="Tidak" />
                    <span>Tidak</span>
                  </label>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Apakah Anda memiliki anak?</label>
                <div class="radio-group">
                  <label class="radio-option">
                    <input type="radio" v-model="hasChildren" value="Ya" />
                    <span>Ya</span>
                  </label>
                  <label class="radio-option">
                    <input type="radio" v-model="hasChildren" value="Tidak" />
                    <span>Tidak</span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Tanggal Lahir Anak :</label>
                <input type="date" v-model="forms.tanggal_lahir_anak_pertama" />
              </div>
            </div>
          </div>
        </div>

        <!-- Form Actions -->
        <div class="form-actions">
          <button type="button" class="btn-cancel" @click="goBack">
            Batal
          </button>
          <button type="submit" class="btn-save" :disabled="isLoading">
            {{ isLoading ? 'Menyimpan...' : 'Simpan Perubahan' }}
          </button>
        </div>
      </form>
    </div>
  </PageLayout>
</template>

<script>
import AppPageLayout from '@/components/ui/PageLayout.vue';

export default {
  name: "NewProfileEdit",
  components: {
    PageLayout: AppPageLayout
  },
  data() {
    return {
      isLoading: false,
      editSection: 'profile', // profile, basic, privacy, additional
      detailUser: {},
      forms: {
        name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: '',
        address: '',
        jenis_kelamin: '',
        tanggal_lahir: '',
        area_domisili: '',
        kode_pos: '',
        skintype: '',
        hijab: '',
        tanggal_lahir_anak_pertama: '',
        tanggal_lahir_anak_kedua: '',
        tanggal_lahir_anak_ketiga: '',
        tanggal_lahir_anak_keempat: '',
        username_instagram: '',
        profile_instagram: '',
        followers_instagram: '',
        engagement_rate_instagram: '',
        username_tiktok: '',
        profile_tiktok: '',
        followers_tiktok: '',
        engagement_rate_tiktok: '',
        device: ''
      },
      file: null,
      imageUrl: "/assets/images/maternity.png",
      community: [],
      modelCommunity: '',
      wagroup: [],
      provinsi: [],
      kota: [],
      kecamatan: [],
      personal: [],
      modelWagroup: "",
      modelProvinsi: {},
      modelKota: {},
      modelKecamatan: "",
      modelPersonal: [],
      hasChildren: 'Tidak',
      errors: []
    };
  },
  computed: {
    pageTitle() {
      switch (this.editSection) {
        case 'profile':
          return 'Profile - Edit Profile';
        case 'basic':
          return 'Profile - Edit Basic Information';
        case 'privacy':
          return 'Profile - Edit Privacy';
        case 'additional':
          return 'Profile - Edit Additional Information';
        case 'social':
          return 'Profile - Edit Social Media';
        default:
          return 'Edit Profile';
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      this.file = event.target.files[0];
      this.previewImage();
    },

    handleFileChangePortofolio(event) {
      this.filePortofolio = event.target.files[0];
    },

    previewImage() {
      if (this.file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageUrl = e.target.result;
        };
        reader.readAsDataURL(this.file);
      }
    },

    validateSelection() {
      if (this.modelPersonal.length > 5) {
        this.modelPersonal = this.modelPersonal.slice(0, 5);
      }
    },

    submitData() {
      this.isLoading = true;
      let formData = new FormData();
      let baseURI = '';
      
      // Determine which endpoint to use based on edit section
      switch (this.editSection) {
        case 'profile':
          baseURI = this.$settings.endPoint + "pengguna/update-profile/" + this.detailUser.user_id;
          formData.append("name", this.forms.name);
          if (this.file) {
            formData.append("image", this.file);
          }
          break;
          
        case 'basic':
          baseURI = this.$settings.endPoint + "pengguna/update-basic-info/" + this.detailUser.user_id;
          formData.append("name", this.forms.name);
          formData.append("phone", this.forms.phone);
          formData.append("address", this.forms.address);
          formData.append("tanggal_lahir", this.forms.tanggal_lahir);
          formData.append("jenis_kelamin", this.forms.jenis_kelamin);
          formData.append("area_domisili", this.forms.area_domisili);
          formData.append("provinsi", this.modelProvinsi.nama || '');
          formData.append("kota", this.modelKota.nama || '');
          formData.append("kecamatan", this.modelKecamatan);
          formData.append("kode_pos", this.forms.kode_pos);
          formData.append("community_id", this.modelCommunity);
          formData.append("personal", this.modelPersonal.join(','));
          break;
          
        case 'privacy':
          baseURI = this.$settings.endPoint + "pengguna/update-privacy/" + this.detailUser.user_id;
          formData.append("email", this.forms.email);
          if (this.forms.password) {
            formData.append("password", this.forms.password);
            formData.append("password_confirmation", this.forms.password_confirmation);
          }
          break;
          
        case 'additional':
          baseURI = this.$settings.endPoint + "pengguna/update-additional-info/" + this.detailUser.user_id;
          formData.append("wa_group", this.modelWagroup);
          formData.append("skintype", this.forms.skintype);
          formData.append("hijab", this.forms.hijab);
          formData.append("tanggal_lahir_anak_pertama", this.forms.tanggal_lahir_anak_pertama);
          formData.append("tanggal_lahir_anak_kedua", this.forms.tanggal_lahir_anak_kedua);
          formData.append("tanggal_lahir_anak_ketiga", this.forms.tanggal_lahir_anak_ketiga);
          formData.append("tanggal_lahir_anak_keempat", this.forms.tanggal_lahir_anak_keempat);
          break;
          
        case 'social':
          baseURI = this.$settings.endPoint + "pengguna/update-social-media/" + this.detailUser.user_id;
          formData.append("username_instagram", this.forms.username_instagram);
          formData.append("profile_instagram", this.forms.profile_instagram);
          formData.append("followers_instagram", this.forms.followers_instagram);
          formData.append("engagement_rate_instagram", this.forms.engagement_rate_instagram);
          formData.append("username_tiktok", this.forms.username_tiktok);
          formData.append("profile_tiktok", this.forms.profile_tiktok);
          formData.append("followers_tiktok", this.forms.followers_tiktok);
          formData.append("engagement_rate_tiktok", this.forms.engagement_rate_tiktok);
          formData.append("device", this.forms.device);
          if (this.filePortofolio) {
            formData.append("portofolio", this.filePortofolio);
          }
          break;
          
        default:
          // Fallback to original endpoint
          baseURI = this.$settings.endPoint + "pengguna/update/" + this.detailUser.user_id;
          Object.keys(this.forms).forEach((key) => {
            if (this.forms[key]) {
              formData.append(key, this.forms[key]);
            }
          });
          formData.append("wa_group", this.modelWagroup);
          formData.append("community_id", this.modelCommunity);
          formData.append("provinsi", this.modelProvinsi.nama || '');
          formData.append("kota", this.modelKota.nama || '');
          formData.append("kecamatan", this.modelKecamatan);
          if (this.file) {
            formData.append("image", this.file);
          }
          if (this.filePortofolio) {
            formData.append("portofolio", this.filePortofolio);
          }
      }

      this.$http
        .post(baseURI, formData, { timeout: 100000 })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.success('Profile updated successfully!');
            // Refetch user data to update UI
            this.fetchUserData();
            // Emit event to update sidebar
            this.$root.$emit('userDataUpdated');
            // Navigate back to profile after a short delay
            setTimeout(() => {
              this.$router.push('/user/profile');
            }, 1500);
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.handleError(error);
        });
    },

    fetchUserData() {
      const userDatas = this.$getUserInfo();
      const userId = userDatas.sub?.user_id;
      
      if (userId) {
        this.isLoading = true;
        const baseURI = this.$settings.endPoint + "get-user/detail/" + userId;
        
        this.$http
          .get(baseURI, {
            timeout: 10000,
            headers: {
              'AppToken': this.$settings.jwtSecret,
            }
          })
          .then((response) => {
            this.isLoading = false;
            if (response.data.status === 200) {
              this.detailUser = response.data.datas;
              this.populateFormData(response.data.datas);
              // Update localStorage with fresh data
              this.updateLocalStorage(response.data.datas);
            } else {
              // Fallback to localStorage data
              this.detailUser = userDatas.sub || {};
              this.populateFormData(this.detailUser);
            }
          })
          .catch(error => {
            this.isLoading = false;
            console.log('Error fetching user data:', error);
            // Fallback to localStorage data
            this.detailUser = userDatas.sub || {};
            this.populateFormData(this.detailUser);
          });
      } else {
        // Fallback to localStorage if no user_id
        this.detailUser = userDatas.sub || {};
        this.populateFormData(this.detailUser);
      }
    },

    getUserImage(imageUrl) {
      // Return default image if no image URL or if it's null/empty
      if (!imageUrl || imageUrl === null || imageUrl === '') {
        return '/assets/images/maternity.png';
      }
      return imageUrl;
    },

    handleImageError(event) {
      // Set default image when image fails to load
      event.target.src = '/assets/images/maternity.png';
    },

    populateFormData(userData) {
      // Populate form with existing data
      Object.keys(this.forms).forEach(key => {
        if (userData[key]) {
          this.forms[key] = userData[key];
        }
      });

      // Set image URL using proper fallback logic
      this.imageUrl = this.getUserImage(userData.image);
      
      // Set model values
      this.modelCommunity = userData.community_id || '';
      this.modelWagroup = userData.wa_group || '';
      
      // Set location data if available
      if (userData.provinsi) {
        this.modelProvinsi = { nama: userData.provinsi, kode: 32 }; // Default kode, you might want to fetch this properly
      }
      if (userData.kota) {
        this.modelKota = { nama: userData.kota };
      }
      if (userData.kecamatan) {
        this.modelKecamatan = userData.kecamatan;
      }
      
      // Set children status
      this.hasChildren = (userData.tanggal_lahir_anak_pertama || userData.tanggal_lahir_anak_kedua || 
                         userData.tanggal_lahir_anak_ketiga || userData.tanggal_lahir_anak_keempat) ? 'Ya' : 'Tidak';
      
      // Set personal data
      if (userData.personal) {
        this.modelPersonal = userData.personal.split(',');
      }
    },

    updateLocalStorage(userData) {
      try {
        const currentUserData = JSON.parse(localStorage.getItem('userModels'));
        if (currentUserData && currentUserData.sub) {
          // Update the user data in localStorage
          currentUserData.sub = { ...currentUserData.sub, ...userData };
          localStorage.setItem('userModels', JSON.stringify(currentUserData));
        }
      } catch (error) {
        console.log('Error updating localStorage:', error);
      }
    },

    loadCommunity() {
      const baseURI = this.$settings.endPoint + "get-community";
      return this.$http
        .get(baseURI, {
          timeout: 10000,
          'headers': {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.community = response.data.datas;
          this.modelCommunity = this.detailUser.community_id;
        })
        .catch(error => {
          console.log('Error loading community:', error);
        });
    },

    loadWagroup() {
      const baseURI = this.$settings.endPoint + "master-wa-group/get-wa-group";
      return this.$http
        .get(baseURI, {
          timeout: 10000,
          'headers': {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.wagroup = response.data.datas;
          this.modelWagroup = this.detailUser.wa_group;
        })
        .catch(error => {
          console.log('Error loading wagroup:', error);
        });
    },

    loadProvinsi() {
      const baseURI = this.$settings.endPoint + "daerah/select-provinsi";
      return this.$http
        .get(baseURI, { timeout: 100000 })
        .then((response) => {
          this.provinsi = response.data.datas;
        })
        .catch(error => {
          console.log('Error loading provinsi:', error);
        });
    },

    loadKota(kode_provinsi) {
      if (!kode_provinsi) return;
      const baseURI = this.$settings.endPoint + "daerah/select-kota/" + kode_provinsi;
      return this.$http
        .get(baseURI, { timeout: 100000 })
        .then((response) => {
          this.kota = response.data.datas;
          this.kecamatan = [];
        })
        .catch(error => {
          console.log('Error loading kota:', error);
        });
    },

    loadKecamatan(kode_kota) {
      if (!kode_kota) return;
      const baseURI = this.$settings.endPoint + "daerah/select-kecamatan/" + kode_kota;
      return this.$http
        .get(baseURI, { timeout: 100000 })
        .then((response) => {
          this.kecamatan = response.data.datas;
        })
        .catch(error => {
          console.log('Error loading kecamatan:', error);
        });
    },

    loadPersonal() {
      const baseURI = this.$settings.endPoint + "master-personal";
      return this.$http
        .get(baseURI, {
          timeout: 10000,
          'headers': {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.personal = response.data.datas;
        })
        .catch(error => {
          console.log('Error loading personal:', error);
        });
    },

    success(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: message,
      });
    },

    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: message,
      });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          this.resultError(error.response.data.errors);
        } else if (error.response.status === 500) {
          this.error(error.response.data.errors.message);
        } else {
          this.$router.push("/page-not-found");
        }
      } else if (error.code === "ECONNABORTED") {
        this.error("Please check your internet connection");
      } else {
        this.error("An error occurred. Please try again.");
      }
    }
  },

  created() {
    // Get edit section from route query
    this.editSection = this.$route.query.section || 'profile';
  },

  mounted() {
    this.fetchUserData();
    this.loadCommunity();
    this.loadWagroup();
    this.loadProvinsi();
    this.loadPersonal();
  }
};
</script>

<style scoped>
/* ========================================= */
/* PROFILE EDIT SECTION                      */
/* ========================================= */
.profile-edit-section {
  padding: 24px 32px;
  margin: 0 auto 32px auto;
  max-width: 1200px;
  width: calc(100% - 64px);
}

.profile-edit-form {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.edit-content {
  margin-bottom: 32px;
}

/* ========================================= */
/* PHOTO SECTION                             */
/* ========================================= */
.photo-section {
  text-align: center;
  margin-bottom: 32px;
}

.profile-photo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.profile-photo {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #F2994A;
}

.change-photo-btn {
  background: #F2994A;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.change-photo-btn:hover {
  background: #e0874a;
}

.photo-info {
  font-size: 0.85rem;
  color: #6B7280;
  margin: 0;
}

.file-info {
  font-size: 0.8rem;
  color: #6B7280;
  margin: 8px 0 0 0;
  font-style: italic;
}

/* ========================================= */
/* FORM SECTIONS                             */
/* ========================================= */
.form-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-weight: 600;
  color: #1F2937;
  font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 16px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #F2994A;
  box-shadow: 0 0 0 3px rgba(242, 153, 74, 0.1);
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.input-with-icon {
  position: relative;
  display: flex;
  align-items: center;
}

.input-with-icon i {
  position: absolute;
  left: 12px;
  color: #6B7280;
  font-size: 1.1rem;
  z-index: 2;
}

.input-with-icon input {
  padding-left: 40px;
}

/* ========================================= */
/* RADIO GROUPS                              */
/* ========================================= */
.radio-group {
  display: flex;
  gap: 16px;
  margin-top: 8px;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.9rem;
}

.radio-option input[type="radio"] {
  width: 18px;
  height: 18px;
  accent-color: #F2994A;
}

/* ========================================= */
/* FORM ACTIONS                              */
/* ========================================= */
.form-actions {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #E5E7EB;
}

.btn-cancel,
.btn-save {
  padding: 12px 32px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-size: 0.9rem;
}

.btn-cancel {
  background: #F3F4F6;
  color: #374151;
}

.btn-cancel:hover {
  background: #E5E7EB;
}

.btn-save {
  background: #F2994A;
  color: white;
}

.btn-save:hover:not(:disabled) {
  background: #e0874a;
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .profile-edit-section {
    width: calc(100% - 40px);
    margin: 0 20px 24px 20px;
    padding: 20px;
  }
  
  .profile-edit-form {
    padding: 24px 20px;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .profile-photo {
    width: 100px;
    height: 100px;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .btn-cancel,
  .btn-save {
    width: 100%;
  }
}
</style>